// Activity Logger Service
import { AuthService } from './authService';

interface ActivityLog {
  action: string;
  module: string;
  details?: any;
  ip_address?: string;
}

export class ActivityLogger {
  /**
   * Loguj akcję użytkownika
   */
  static async log(action: string, module: string, details?: any) {
    try {
      const user = AuthService.getCurrentUser();
      if (!user) return;

      // Zapisz lokalnie dla szybkiego dostępu
      const localLogs = JSON.parse(localStorage.getItem('plexisystem_activity_logs') || '[]');
      const newLog = {
        id: Date.now(),
        user: user.email,
        action,
        module,
        timestamp: new Date().toISOString(),
        ip: 'client',
        details
      };
      
      localLogs.unshift(newLog);
      // Zachowaj tylko ostatnie 100 logów lokalnie
      if (localLogs.length > 100) {
        localLogs.length = 100;
      }
      localStorage.setItem('plexisystem_activity_logs', JSON.stringify(localLogs));

      // Wyślij do backend
      try {
        await AuthService.fetchWithAuth('/api/activity/log', {
          method: 'POST',
          body: JSON.stringify({
            action,
            module,
            details
          })
        });
      } catch (error) {
        console.error('Nie udało się wysłać logu do backend:', error);
      }
    } catch (error) {
      console.error('Błąd logowania aktywności:', error);
    }
  }

  /**
   * Loguj logowanie użytkownika
   */
  static async logLogin() {
    await this.log('Zalogowano do systemu', 'auth');
  }

  /**
   * Loguj wylogowanie
   */
  static async logLogout() {
    await this.log('Wylogowano z systemu', 'auth');
  }

  /**
   * Loguj tworzenie zasobu
   */
  static async logCreate(resource: string, details?: any) {
    await this.log(`Utworzono ${resource}`, resource, details);
  }

  /**
   * Loguj aktualizację zasobu
   */
  static async logUpdate(resource: string, details?: any) {
    await this.log(`Zaktualizowano ${resource}`, resource, details);
  }

  /**
   * Loguj usunięcie zasobu
   */
  static async logDelete(resource: string, details?: any) {
    await this.log(`Usunięto ${resource}`, resource, details);
  }

  /**
   * Loguj dostęp do modułu
   */
  static async logModuleAccess(moduleName: string) {
    await this.log(`Otworzono moduł ${moduleName}`, moduleName);
  }

  /**
   * Loguj eksport danych
   */
  static async logExport(type: string, details?: any) {
    await this.log(`Eksportowano ${type}`, 'export', details);
  }

  /**
   * Loguj błąd
   */
  static async logError(error: string, module: string, details?: any) {
    await this.log(`Błąd: ${error}`, module, { error, ...details });
  }
}
